// extracted by mini-css-extract-plugin
module.exports = {"loadMenu":"LoadMenu_loadMenu__1Qv-1","savedLevel":"LoadMenu_savedLevel__1-4sg","level":"LoadMenu_level__RXW45"};